import { IDynamicQueryService } from "../../service/dynamicQuery/DynamicQueryService";

export default class DeleteDynamicQueryInteractor {
  private dynamicQueryService: IDynamicQueryService;

  constructor(dynamicQueryService) {
    this.dynamicQueryService = dynamicQueryService;
  }

  async execute(code: string) {
    return this.dynamicQueryService.deleteDynamicQuery(code);
  }
}
